import { useEffect, useState } from 'react';

/** Current time (epoch ms), re-rendering every `intervalMs`, aligned to the interval boundary. */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    let timer: number;
    const tick = () => {
      const t = Date.now();
      setNow(t);
      timer = window.setTimeout(tick, intervalMs - (t % intervalMs) + 5);
    };
    timer = window.setTimeout(tick, intervalMs - (Date.now() % intervalMs) + 5);
    return () => window.clearTimeout(timer);
  }, [intervalMs]);
  return now;
}
